export default __webpack_public_path__ + "static/media/1281677.baf95c6d.jpg";